import { FormMappingOption } from '@app/utils/form-mapping/models/form-mapping-option';
import { UserLevel } from './user-level';

const METADATA_KEY = '__portal_metadata__';

export interface PortalMetadata {
  // Used to transport form attributes (see form-mapping.ts and form-mapping-attribute.ts)
  formAttributes?: FormMappingOption[];

  // Used to define a required user level for a component
  requiredUserLevel?: UserLevel;
}

export function getMetadata(component): PortalMetadata {
  return (component || {})[METADATA_KEY] || {};
}

export function setMetadata(component, metadata: PortalMetadata) {
  component[METADATA_KEY] = {
    ...getMetadata(component),
    ...metadata,
  };
}
